import { TableCellComponentProps } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { Icon } from '@/modules/Icon';
import { TruncatedWithTooltip } from '@/modules/Tooltip';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  isFlexColumn,
} from '../../utils/cellStyles';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

export const StarsCell = ({
  value,
  column,
  state = 'default',
  className,
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    undefined,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto),
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  const rating =
    typeof value === 'number' ? value : typeof value === 'string' ? parseFloat(value) || 0 : 0;

  const isActive = (state === 'selected' || state === 'focused') && !isRowEditing;

  const hasFixedWidth = column.width !== undefined;
  return (
    <td className={baseClasses} {...cellProps} onClick={(e) => handleCellClick(e, onCellFocus)}>
      <div
        className={cn(
          'ui-flex ui-items-center ui-gap-2',
          hasFixedWidth && 'ui-min-w-0 ui-overflow-hidden',
        )}
      >
        <Icon
          name={faStar}
          size="md"
          color={isActive ? 'brand' : 'yellow'}
          className="ui-shrink-0"
        />
        <TruncatedWithTooltip
          truncate={hasFixedWidth}
          title={rating.toFixed(1)}
          className={cn(
            'ui-text-sm ui-font-normal ui-leading-[20.5px] ui-tracking-[0.5px]',
            hasFixedWidth && 'ui-min-w-0',
          )}
        >
          {rating.toFixed(1)}
        </TruncatedWithTooltip>
      </div>
    </td>
  );
};
